var a = /* @__PURE__ */ ((e) => (e[e.Claim = 2522713783] = "Claim", e[e.BurnRedeem = 2520944311] = "BurnRedeem", e[e.FarcasterMint = 2521976503] = "FarcasterMint", e[e.OneOfOne = 2524270263] = "OneOfOne", e[e.Edition = 2528808631] = "Edition", e[e.SeriesSingle = 2528857783] = "SeriesSingle", e[e.SeriesMultiple = 2521435831] = "SeriesMultiple", e[e.Marketplace = 2520993463] = "Marketplace", e[e.Curate = 2533641911] = "Curate", e[e.Thanks = 2526039735] = "Thanks", e[e.ContractDeploy = 2525499063] = "ContractDeploy", e[e.Serendipity = 2526777015] = "Serendipity", e[e.Physicals = 2526564023] = "Physicals", e[e.Giveaway = 2525023927] = "Giveaway", e[e.Scribe = 2532871863] = "Scribe", e))(a || {});
const r = [
  2522713783,
  2520944311,
  2520993463,
  2533641911,
  2526777015,
  2526564023,
  2525023927,
  2532871863
  /* Scribe */
], i = {
  2522713783: { slug: "c", readableName: "Claim", name: "claim" },
  2520944311: { slug: "br", readableName: "Burn Redeem", name: "burn_redeem" },
  2520993463: { slug: "", readableName: "Marketplace", name: "marketplace" },
  2533641911: { slug: "t", readableName: "Curate", name: "curate" },
  2526777015: { slug: "draw", readableName: "Serendipity", name: "serendipity" },
  2526564023: { slug: "phy", readableName: "Physicals", name: "physicals" },
  2525023927: { slug: "give", readableName: "Giveaway", name: "giveaway" },
  2532871863: { slug: "txt", readableName: "Scribe", name: "scribe" }
};
export {
  i as A,
  r as C,
  a
};
